import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import GeometricBackground from './components/GeometricBackground';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import FoundationPage from './pages/FoundationPage';
import PortfolioPage from './pages/PortfolioPage';
import ServicesPage from './pages/ServicesPage';
import GRCServicesPage from './pages/GRCServicesPage';
import FinancialServicesPage from './pages/FinancialServicesPage';
import WorkforceSolutionsPage from './pages/WorkforceSolutionsPage';
import CertificationsPage from './pages/CertificationsPage';
import PolymathyPage from './pages/PolymathyPage';
import MediaPage from './pages/MediaPage';
import AffiliatesPage from './pages/AffiliatesPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navigation />
        <GeometricBackground />
        <Routes>
          <Route path="/" element={<MediaPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/foundation" element={<FoundationPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/grc" element={<GRCServicesPage />} />
          <Route path="/services/financial" element={<FinancialServicesPage />} />
          <Route path="/services/workforce" element={<WorkforceSolutionsPage />} />
          <Route path="/certifications" element={<CertificationsPage />} />
          <Route path="/polymathy" element={<PolymathyPage />} />
          <Route path="/media" element={<MediaPage />} />
          <Route path="/affiliates" element={<AffiliatesPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

